import React, { Component } from "react";
import {
  getUser,
  history,
  getQueryParams,
  handleUserRedirectionForOnMainRoute
} from "./helpers";

class CheckAuth extends Component {
  componentDidMount() {
    const pathName = window.location.pathname;
    const urlParams = getQueryParams(window.location.search);

    const shortLinkParam = urlParams["s"];

    if (getUser()) {
      handleUserRedirectionForOnMainRoute();
    }

    if (getUser() && shortLinkParam && pathName != "/k") {
      history.push(`/k?c=${shortLinkParam}`);
    } else if (!getUser()) {
      if (shortLinkParam && pathName != "/k") {
        history.push(`/k?c=${shortLinkParam}`);
        return false;
      } else if (pathName != "/k") {
        history.push("/sign-in");
      }
    }
  }

  render() {
    return <div />;
  }
}

export default CheckAuth;
